<template>
  <form
    method="GET"
    :action="section.link"
    class="search-container"
    :class="{ active: showSearch }"
    @submit="handleSubmitForm"
    @keyup.esc="toggleSearch"
  >
    <input
      v-if="showSearch"
      id="search"
      ref="searchInput"
      v-model="searchString"
      name="search"
      class="search-input"
      :placeholder="section.placeholder"
      @keyup.enter="handleSubmitForm"
    />
    <button
      class="search"
      type="button"
      :aria-label="section.title"
      @click="toggleSearch"
    >
      <v-lazy-image
        :src="section.icon.source"
        :alt="section.icon.alt"
        width="24"
        height="24"
        class="icon"
      />
    </button>
  </form>
</template>

<script>
  import VLazyImage from 'v-lazy-image'

  export default {
    components: {
      VLazyImage
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        searchString: '',
        showSearch: false
      }
    },
    methods: {
      toggleSearch() {
        this.showSearch = !this.showSearch
        this.searchString = ''

        if (this.showSearch) {
          this.$nextTick(() => {
            this.$refs.searchInput?.focus()
          })
        }
      },
      handleSubmitForm(e) {
        if (e.type !== 'submit') {
          e.preventDefault()
          return
        }

        if (this.searchString === '') {
          e.preventDefault()
          return
        }
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .icon {
    width: 24px;
    height: 24px;
  }

  .search-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    gap: rem(16, 16);
    border-radius: 4px;
    border: 1px solid transparent;

    .search-input {
      font-size: rem(16, 16);
      line-height: rem(24, 16);
      padding: 0 0 0 15px;
      flex: 0 1 100%;

      @include input-placeholder {
        color: $scn-gray-text;
      }
    }

    &.active {
      border: 1px solid $scn-gray-border;
      width: 320px;
      margin: -8px;

      .search-input {
        height: 48px;
      }

      .search {
        margin-right: 8px;
      }
    }
  }

  .search {
    padding: 0;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
  }
</style>
